<template>
  <div>
    <v-container grid-list-xs  pt-0>
      <v-layout row wrap>
        <v-flex lg12>
          <v-flex lg8 offset-lg2 v-if="externalProductionReport">
            <ProductionReportCard :image="externalProductionReport"></ProductionReportCard>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import ProductionReportCard from "./ProductionReportCard";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["externalProductionReport", "loadingExternal","agency"])
  },
  mounted() {
    this.$store.dispatch("external");
  },
  components: {
    ProductionReportCard
  },
  methods:{},
  watch: {
    loadingExternal(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando configuración");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(){
      this.$store.dispatch("external");
    }
  },
  data() {
    return {};
  }
};
</script>